import { render } from "./BannerSectionCmp.vue?vue&type=template&id=3bdafb4b"
import script from "./BannerSectionCmp.vue?vue&type=script&lang=js"
export * from "./BannerSectionCmp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\working\\MyCi4Vue\\myCi4Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__